import { FormElementPlugin } from '../FormElementPlugin';
import {
  DynamicFormMultipleChoice,
  DynamicFormMultiSelectConfig
} from './FormMultiSelectPlugin';

export const FormYesNoPlugin: FormElementPlugin<
  any,
  DynamicFormMultiSelectConfig
> = {
  name: 'Yes/No (True/False)',
  type: 'Boolean',
  dataTypes: ['boolean'],
  element: DynamicFormMultipleChoice
};
